import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import AdminLayout from './AdminLayout';
import { Row, Col, Icon } from 'antd';
import { Link } from 'react-router-dom';

export class Home extends Component {
  static propTypes = {
    admin: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    return (
      <AdminLayout
        title="DASHBOARD"
      >
        <Row className="admin-home">
          <Col style={{ marginTop: '60px' }} xs={{ span: 22, offset: 1 }}>
            <Col xs={{ span: 22, offset: 1 }} md={{ span: 22, offset: 1 }} lg={{ span: 7, offset: 1 }} className="dashboard-item">
              <Link to="/admin/events">
                <Col xs={{ span: 24 }} md={{ span: 8 }} lg={{ span: 8 }} className="icon blue">
                  <Icon type="tags" />
                </Col>
                <Col xs={{ span: 24 }} md={{ span: 16 }} lg={{ span: 16 }} className="dashboard-content font-blue">
                  <Col span={24}>
                    59
              </Col>
                  <Col span={24}>
                    <span>événements</span>
                  </Col>
                </Col>
              </Link>
            </Col>
            <Col xs={{ span: 22, offset: 1 }} md={{ span: 22, offset: 1 }} lg={{ span: 7, offset: 1 }} className="dashboard-item">
              <Link to="/admin/users">
                <Col xs={{ span: 24 }} md={{ span: 8 }} lg={{ span: 8 }} className="icon green">
                  <Icon type="user" />
                </Col>
                <Col xs={{ span: 24 }} md={{ span: 16 }} lg={{ span: 16 }} className="dashboard-content font-green">
                  <Col span={24}>
                    1899
              </Col>
                  <Col span={24}>
                    <span>utilisateurs</span>
                  </Col>
                </Col>
              </Link>
            </Col>
            <Col xs={{ span: 22, offset: 1 }} md={{ span: 22, offset: 1 }} lg={{ span: 7, offset: 1 }} className="dashboard-item">
              <Link to="/admin/events/top">
                <Col xs={{ span: 24 }} md={{ span: 8 }} lg={{ span: 8 }} className="icon red">
                  <Icon type="star" />
                </Col>
                <Col xs={{ span: 24 }} md={{ span: 16 }} lg={{ span: 16 }} className="dashboard-content font-red">
                  <Col span={24}>
                    6
              </Col>
                  <Col span={24}>
                    <span>événements à la une</span>
                  </Col>
                </Col>
              </Link>
            </Col>
          </Col>
        </Row>
      </AdminLayout >
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    admin: state.admin,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);



// WEBPACK FOOTER //
// ./src/features/admin/Home.js